/*
 * Author: Dw
 * File Created: Wednesday, 24-07-17 09:27 pm
 * Last Modified: Tuesday, 24-11-19 03:11 pm, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
function Close() {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="Close" data-sentry-source-file="index.tsx">
      <path d="M17.7273 19.0002C18.0788 19.3517 18.6487 19.3517 19.0002 19.0002C19.3408 18.6596 19.3625 18.0896 19.0002 17.7273L13.2727 11.9999L19.0002 6.27239C19.3517 5.9209 19.3517 5.35102 19.0002 4.99953C18.6596 4.65892 18.0896 4.63726 17.7273 4.99953L11.9999 10.727L6.27235 4.99946C5.92086 4.64797 5.35098 4.64797 4.99948 4.99946C4.65887 5.34007 4.63721 5.91005 4.99948 6.27232L10.727 11.9999L4.99949 17.7274C4.64799 18.0789 4.64799 18.6488 4.99948 19.0002C5.3401 19.3409 5.91008 19.3625 6.27235 19.0002L11.9999 13.2727L17.7273 19.0002Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default Close;